import styled, { keyframes } from 'styled-components';

const moveTo = keyframes`
  0%{
    top: 74px;

  }

  50%{
    top:82px;
  }

  75%{
    top: 90px;
  }

  100%{
    top: 98px;
  }
`;

export const Container = styled.div`
    align-items: center;
    background-color: ${({ theme, isSuccess }) => {
    if (isSuccess) {
      return theme.colors.success;
    }

    return theme.colors.error;
  }};
    border-radius: 8px;
    display: flex;
    top: 98px;
    height: 48px;
    justify-content: start;
    padding: 16px;
    position: absolute;
    right: 32px;
    width: 328px;
    animation: ${moveTo} .4s ease-in 0s 1;


    span{
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }
`;
